import { useState } from "react";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";

import { ICreatorCard } from "../../../@types";
import { MY_CREATOR_CARDS } from "../../../GraphQL/competitions";
import {
  GET_MOMENT,
  MOMENT_CREATE_CLIP,
} from "MVVM/GraphQL/mutations/momentRequestClip";

interface MyCreatorCardsData {
  myCreatorCards: ICreatorCard[];
}

const RemixModalViewModel = (momentId: string) => {
  const [myCreatorCards, setMyCreatorCards] = useState<ICreatorCard[]>();
  const { data } = useQuery(GET_MOMENT, {
    variables: { id: momentId },
    skip: !momentId,
  });
  const { loading } = useQuery<MyCreatorCardsData>(MY_CREATOR_CARDS, {
    fetchPolicy: "network-only",
    onCompleted: (data: MyCreatorCardsData) =>
      setMyCreatorCards(data.myCreatorCards),
  });

  const [momentCreateClip] = useMutation(MOMENT_CREATE_CLIP, {
    onError: (err: any) => {
      console.log(`mutateReaction error! ${err.message}`);
    },
  });

  return {
    loading,
    myCreatorCards,
    momentCreateClip,
    moment: data?.moment,
  };
};

export { RemixModalViewModel };
